import { SAVE_APP_SETTINGS_DATA } from "./typeConstants";

export const saveAppSettings = (appSettings) => ({
  type: SAVE_APP_SETTINGS_DATA,
  payload: {
    appSettings
  }
});
